import { render, staticRenderFns } from "./progressLoading.vue?vue&type=template&id=1bfb2bde&scoped=true"
import script from "./progressLoading.vue?vue&type=script&lang=js"
export * from "./progressLoading.vue?vue&type=script&lang=js"
import style0 from "./progressLoading.vue?vue&type=style&index=0&id=1bfb2bde&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfb2bde",
  null
  
)

export default component.exports